module.exports = __webpack_public_path__ + "img/measurement.400efde9.svg";